import { useEffect } from "react";
import { isElectron } from "../../lib/platform";
import { coreStore } from "../../lib/stores/core-store";
import { uiStore } from "../../lib/stores/ui-store";

export function DeepLinkHandler() {
	useEffect(() => {
		if (!isElectron) return;

		const api = (
			window as unknown as {
				api?: {
					deepLink?: { onNavigate: (cb: (path: string) => void) => void };
				};
			}
		).api;
		console.log(
			"[DeepLinkHandler] Registering listener, api.deepLink:",
			!!api?.deepLink
		);
		api?.deepLink?.onNavigate((path) => {
			console.log("[DeepLinkHandler] Received navigate path:", path);

			// The optional workspace prefix, /w/:workspaceId/...
			const workspaceMatch = path.match(/^\/w\/([^/]+)(\/.*)?$/);
			const workspaceId = workspaceMatch?.[1] ?? null;
			const remainingPath = workspaceMatch
				? (workspaceMatch[2] ?? "/app")
				: path;

			console.log(
				"[DeepLinkHandler] workspaceId:",
				workspaceId,
				"remainingPath:",
				remainingPath
			);

			if (workspaceId) {
				const currentWorkspaceId = uiStore.getState().currentWorkspaceId;
				if (currentWorkspaceId !== workspaceId) {
					console.log(
						"[DeepLinkHandler] Switching workspace from",
						currentWorkspaceId,
						"to",
						workspaceId
					);
					// selectWorkspace sets the id and runs the sequential workspace-data
					// load, which replaced the removed sidebar fan-out effect.
					coreStore.getState().selectWorkspace(workspaceId);
				}
			}

			// Parse /app/:channelId or /app/:channelId/thread/:threadId
			const channelMatch = remainingPath.match(
				/^\/app\/([^/]+)(?:\/thread\/([^/]+))?$/
			);
			if (channelMatch) {
				const [, channelId, threadId] = channelMatch;
				console.log(
					"[DeepLinkHandler] Navigating to channel:",
					channelId,
					"thread:",
					threadId
				);
				if (threadId) {
					uiStore
						.getState()
						.navigate({ type: "thread", params: { channelId, threadId } });
				} else {
					uiStore
						.getState()
						.navigate({ type: "textChannel", params: { channelId } });
				}
			}
		});
	}, []);

	return null;
}
